import React from "react";
import { useRecoveryTracker } from "../context/RecoveryTrackerContext";
import RecoveryTrackerOptions from "./RecoveryTrackerOptions";

const RecoveryTrackerModal = () => {
  const { showRecoveryTracker, setShowRecoveryTracker } = useRecoveryTracker();
  const selectedUserId = sessionStorage.getItem("userId");

  if (!showRecoveryTracker) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center"
      onClick={(e) => e.stopPropagation()}
    >
      <RecoveryTrackerOptions
        isOpen={showRecoveryTracker}
        onClose={() => setShowRecoveryTracker(false)}
      />
    </div>
  );
};

export default RecoveryTrackerModal;
